var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HelpListPage',{attrs:{"id":"HELP_PAGE_EDITING","heading":_vm.$t('helpPage.editPage.heading'),"title":_vm.$t('helpPage.editPage.title'),"description":_vm.$t('helpPage.editPage.description')}})}
var staticRenderFns = []

export { render, staticRenderFns }